export default class Item {
  value!: string | null
  text!: string | null
}
